import SportEventMapper from './sport-event-mapper';
import SportEventModelBase from '../../agent/sport-event/sport-event-model';
import CategoryModel from '../../agent/category/category-model';
import SeasonModel from '../season/season-model';

const SportEventModel = {
    ...SportEventModelBase,

    mapper: SportEventMapper,

    category: {
        fieldName: 'c',
        model: CategoryModel,
        type: Object,
    },

    season: {
        fieldName: 'n',
        model: SeasonModel,
        modelContext: {
            category: 'category',
        },
        type: Object,
    },
};

export default SportEventModel;
